module.exports = __webpack_public_path__ + "static/media/4-item-c.afe19b27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/4-item-c.jpg
// module id = 1169
// module chunks = 33